const SERVICE_LANGUAGE = {
  tr: 'tr-TR',
  en: 'en-US',
  de: 'de-DE'
};
export { SERVICE_LANGUAGE };
